// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

const getCookieValue = (name) =>
  document.cookie
    .split(";")
    .find((cookieStr) => cookieStr.trim().startsWith(`${name}=`))
    ?.split("=")[1];

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("cart:updated", function (_evt) {
  const ssUserId = getCookieValue("ssUserId");
  const ssSessionIdNamespace = getCookieValue("ssSessionIdNamespace");

  if (ssUserId) {
    fetch("/cart/update.js", {
      method: "POST",
      body: JSON.stringify({
        attributes: {
          ssUserId,
          ssSessionIdNamespace,
        },
      }),
      headers: {
        "content-type": "application/json",
      },
    });
  }
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("cart:error", function (evt) {
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("quick-cart:open", function (evt) {
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("quick-cart:close", function () {
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("product:variant-change", function (evt) {
  const metafields = JSON.parse(document.querySelector('[data-product-metafields-json]').innerText)

  if (evt.detail.variant?.available && !metafields.forceOutOfStock) {
    document.querySelector('.paypal-installments')?.classList.remove('hidden');
    document.querySelector('.dynamic-checkout__wrapper')?.classList.remove('hidden');
  }
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("product:quantity-update", function (evt) {
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
});
